<template>
  <div class="main overflow-hidden">
    <div class="banner"></div>
    <div class="intro flex">
      <div class="flex-1 !h-[438px]">
        <v-player class="" :src="productstate.video" :cover="productstate.video_cover" aspectRatio="698:438" />
      </div>
      <div class="intro__info">
        <h2 class="title mb-[35px]">招商伊敦号档案</h2>
        <ul class="cruise__info text-dark text-xl">
          <li class="flex items-center :not-last:mb-[15px]">
            <span class="w-[100px]">载客量</span>
            <span class="">930位宾客</span>
          </li>
          <li class="flex items-center :not-last:mb-[15px]">
            <span class="w-[100px]">总吨数</span>
            <span class="">47,800吨</span>
          </li>
          <li class="flex items-center :not-last:mb-[15px]">
            <span class="w-[100px]">甲板</span>
            <span class="">9层</span>
          </li>
          <li class="flex items-center :not-last:mb-[15px]">
            <span class="w-[100px]">船长</span>
            <span class="">约227米</span>
          </li>
          <li class="flex items-center :not-last:mb-[15px]">
            <span class="w-[100px]">船宽</span>
            <span class="">约28.8米</span>
          </li>
          <li class="flex items-center :not-last:mb-[15px]">
            <span class="w-[100px]">类别</span>
            <span class="">中小型船舶</span>
          </li>
          <li class="flex items-center :not-last:mb-[15px]">
            <span class="w-[100px]">船龄</span>
            <span class="">5年（2017年交付）</span>
          </li>
        </ul>
      </div>
    </div>
    <WhyChoice></WhyChoice>
    <DeliciousFood></DeliciousFood>
    <CultureEntertainment></CultureEntertainment>
    <CulturePace></CulturePace>
    <AdenCabin></AdenCabin>
    <AdenProduct :products="productstate.product"></AdenProduct>
  </div>
</template>
<script>
import { getZhaoshang } from "@/services/special.js";
import useRequest from "@/composables/useRequest";
import {  defineComponent } from "@nuxtjs/composition-api";
// import { ProductTypes } from "@/constants/productType";
import { profitFormat } from "@/utils/product.js";
import VPlayer from "~/components/VPlayer/index.vue";
import AdenTitle from "~/views/topic/202208/aden/components/aden-title.vue";
import WhyChoice from "~/views/topic/202208/aden/components/why-choice.vue";
import DeliciousFood from "~/views/topic/202208/aden/components/delicious-food.vue";
import CultureEntertainment from "~/views/topic/202208/aden/components/culture-entertainment.vue";
import CulturePace from "~/views/topic/202208/aden/components/culture-place.vue";
import AdenCabin from "~/views/topic/202208/aden/components/aden-cabin.vue";
import AdenProduct from "~/views/topic/202208/aden/components/aden-product.vue";
import { useMeta, useFetch } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "TopicAden",
  auth: false,
  head: {
    title: "招商伊顿号"
  },
  components: {
    VPlayer,
    AdenTitle,
    WhyChoice,
    DeliciousFood,
    CultureEntertainment,
    CulturePace,
    AdenCabin,
    AdenProduct,
  },
  setup() {
    useMeta(() => ({
      title: "招商伊顿号"
    }));

    let { state: productstate, execute } = useRequest(() => getZhaoshang(), {
      product: [],
      video: "",
      video_cover: "",
    }, {
      immediate: false,
    });

    useFetch(async () => {
      await execute(0);
    });
    
    return {
      productstate,
    };
  },
  methods: {
    profitFormat,
  },
})
</script>
<style lang="scss" scoped>
.main {
  font-size: 1rem;
  line-height: 1.5rem;
}
.banner {
  height: 946px;
  background: url(~views/topic/202208/aden/imgs/banner_bg.png) no-repeat center;
  background-position: center center;
  background-size: auto 946px;
}
.intro {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.125rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 470px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -100px;
  padding: 16px;
  width: 1100px;
  box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.2);
}
.intro .title {
  font-size: 32px;
  line-height: 1;
  padding-left: 20px;
  position: relative;
  --tw-text-opacity: 1;
  color: rgba(198, 161, 74, var(--tw-text-opacity));
}
.intro .title::before {
  content: "";
  --tw-bg-opacity: 1;
  background-color: rgba(198, 161, 74, var(--tw-bg-opacity));
  border-radius: 0.125rem;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 8px;
}
.intro__info {
  padding-left: 54px;
  width: 370px;
}
.cruise__info li {
  line-height: 2;
}
</style>
